<template>
  <div class="dashboard-graph-wrapper">
    <v-container class="pa-0">
      <v-row no-gutters align="center" class="mx-n4">
        <v-col
          v-for="(zmluva, index) in zmluvy"
          :key="index"
          xl="3"
          lg="3"
          md="3"
          class="px-4"
        >
          <v-card elevation="0">
            <p class="label">{{ zmluva.label }}</p>
            <p class="number">{{ zmluva.pocet }}</p>
            <v-img contain src="../../assets/img/graf.png"></v-img>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      zmluvy: [
        { pocet: 10, label: 'Nové' },
        { pocet: 15, label: 'V riešení' },
        { pocet: 40, label: 'Manuálne posúdenie' },
        { pocet: 120, label: 'Všetky' },
      ],
    };
  },
};
</script>
